import axios from "axios";

export const state = {
    stocks: [],
};

export const getters = {
    stocks: state => state.stocks,
};

export const mutations = {
    setStock(stocks, newValue) { state.stocks = newValue},
};

export const actions = {
    fetchStock({ commit }) {
        axios.get('/viewstocks').then(res => {
            commit('setStock', res.data.inventorys)
        })
    },
    filterStock({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterstocks";
        axios.post(url, formData).then((response) => {
            commit('setStock', response.data.inventorys)
        })
    },
};
